import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { Sgke131aResponseBasicInfo } from 'sg-api';

@Component({
  selector: 'app-sgke130d-basic-info',
  templateUrl: './sgke130d-basic-info.component.html',
  styleUrl: './sgke130d-basic-info.component.scss'
})
export class Sgke130dBasicInfoComponent implements OnInit, OnDestroy {
  /** 基本情報データ */
  @Input() basicInfo: Sgke131aResponseBasicInfo;

  /**
   * 初期処理
   * 
   * @memberof Sgke130dBasicInfoComponent
   */
  ngOnInit(): void {
  }

  /**
   * コンポーネントが破棄される際に呼び出されるライフサイクルフック
   * リソースの解放や購読の解除
   * 
   * @memberof Sgke130dBasicInfoComponent
   */
  ngOnDestroy(): void {
  }

}
